<div id="ftp-sweep">
    <mat-card-header>
        <div class="search-section auto-margin">{{ 'CUSTOMER_EDITOR.FTP_CONFIGURATION' | translate }}</div>
        <div class="app-flex-filler"></div>
    </mat-card-header>
    <mat-card-content>
        <app-loader [isLoading]="loadingState"></app-loader>
        <!-- FTP Server table -->
        <div id="ftpTable" *ngIf="totalPaginationLength > 0">
            <mat-table #table [dataSource]="ftpDataSource" matSort class="edit-cus-ftp-table-hint">
                <!-- FTP Server table column 1 -->
                <ng-container matColumnDef="protocol">
                    <mat-header-cell *matHeaderCellDef>{{ 'ADMIN.FTP_SWEEP.PROTOCOL' | translate }}</mat-header-cell>
                    <mat-cell *matCellDef="let element">{{ protocols[element.protocol] }}</mat-cell>
                </ng-container>
                <!-- FTP Server table column 2 -->
                <ng-container matColumnDef="server">
                    <mat-header-cell *matHeaderCellDef>{{ 'CUSTOMER_EDITOR.FTP_SERVER' | translate }}</mat-header-cell>
                    <mat-cell class="description-space" *matCellDef="let element">{{ element.server }} </mat-cell>
                </ng-container>
                <!-- FTP Server table edit icon -->
                <ng-container matColumnDef="action">
                    <mat-header-cell *matHeaderCellDef class="fixCellWidth"></mat-header-cell>
                    <mat-cell *matCellDef="let element" class="text-right">
                        <mat-icon matTooltip="{{ 'COMMON.EDIT_TOOLTIP' | translate }}" (click)="editFTPServer(element)">mode_edit</mat-icon>
                        <mat-icon matTooltip="{{ 'COMMON.DELETE_BUTTON' | translate }}" (click)="deleteFTPServer(element.guid)">delete</mat-icon>
                    </mat-cell>
                </ng-container>
                <!-- FTP Server table delete icon -->

                <mat-header-row *matHeaderRowDef="ftpDescriptionColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: ftpDescriptionColumns"></mat-row>
            </mat-table>
        </div>
        <div class="notabledataFound custom-table" *ngIf="!loadingState && totalPaginationLength === 0">
            {{ 'ADMIN.NO_DATA_AVAILABLE' | translate }}
        </div>
    </mat-card-content>
    <mat-paginator hidden [length]="totalPaginationLength" [pageIndex]="0" [pageSize]="10"></mat-paginator>
</div>
